import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scroll to top on every route change.
 * Mounted once at the App root inside <BrowserRouter>.
 * If the URL has a #hash, scrolls to the matching element instead.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
                return;
            }
        }
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}
